// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__WcT5f","icon":"styles_icon__TZ994","label":"styles_label__xANvk"};